import { render, staticRenderFns } from "./ApplicationFilesSection.vue?vue&type=template&id=1397b9ba&scoped=true&"
import script from "./ApplicationFilesSection.vue?vue&type=script&lang=ts&"
export * from "./ApplicationFilesSection.vue?vue&type=script&lang=ts&"
import style0 from "./ApplicationFilesSection.vue?vue&type=style&index=0&id=1397b9ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1397b9ba",
  null
  
)

export default component.exports